<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Usuwanie wpisu
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                Czy na pewno chcesz usunąć wpis?
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="info"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    :loading="actionLoading"
                    color="error"
                    text
                    data-sentry-label="Usuń"
                    @click="deleteProcessEntry(processEntry)"
                >
                    Usuń
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'DeleteProcessEntryDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        processEntry: {
            type: Object,
            default: null
        },
        actionLoading: {
            type: Boolean
        }
    },
    methods: {
        deleteProcessEntry(processEntry) {
            this.$emit('on-confirm', processEntry)
            this.onClose()
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>

